import { format } from "date-fns";

export const getMostRecentDate = (dates: (Date | null)[]): Date | null => {
    return dates.reduce((acc, date) => {
        return date && acc && acc > date ? acc : date;
    });
};

export const dateOrNull = (date: Date | null | undefined): Date | null => {
    return date ? new Date(date) : null;
};

export const getCurrentDate = (dateFormat?: string): string => {
    const date = new Date();
    return formatDate(date, dateFormat);
};

export const formatDate = (date: Date, dateFormat = "do MMMM yyyy"): string => {
    return format(date, dateFormat);
};

export const getDateFormatFromCMSEnumeration = (
    exampleString: string | undefined
): string | null => {
    const startingLetter = exampleString?.charAt(0);
    switch (startingLetter) {
        case "A":
            // 10th September 2024
            return "do MMMM yyyy";
        case "B":
            // September 2024
            return "MMMM yyyy";
        case "C":
            // Tuesday, September 10th, 2024, 14:30
            return "EEEE, MMMM do yyyy, HH:mm";
        case "D":
            // Tuesday, September 10th, 2024, 2:30 PM
            return "EEEE, MMMM do, yyyy, h:mm a";
        case "E":
            // No date
            return null;
    }
    return "do MMMM yyyy";
};
